import { FaMapMarked } from "react-icons/fa";

const ContactCards = () => {
  return (
    <div className="bg-nightSoft">
      <div className="max-w-[1140px] mx-auto p-4 pt-24 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          <div className="w-full p-4 sm:p-6 glass-card py-10 sm:py-16 lg:py-20">
            <div className="flex justify-center pb-8">
              <FaMapMarked size={50} className="text-customRed" />
            </div>
            <h5 className="mb-2 text-xl sm:text-2xl font-bold text-white text-center">
              USA
            </h5>
            <p className="mb-3 font-normal text-gray-400 text-center text-base sm:text-lg">
              1740 Innovation Dr. Suite # 210 Carbondale, IL. 62903. USA.
            </p>
          </div>
          <div className="w-full p-4 sm:p-6 glass-card py-10 sm:py-16 lg:py-20">
            <div className="flex justify-center pb-8">
              <FaMapMarked size={50} className="text-customRed" />
            </div>
            <h5 className="mb-2 text-xl sm:text-2xl font-bold text-white text-center">
              Pakistan
            </h5>
            <p className="mb-3 font-normal text-gray-400 text-center text-base sm:text-lg">
              Local Branch:Trade Center Gujranwala,Pakistan
            </p>
          </div>
          <div className="w-full p-4 sm:p-6 glass-card py-10 sm:py-16 lg:py-20">
            <div className="flex justify-center pb-8">
              <FaMapMarked size={50} className="text-customRed" />
            </div>
            <h5 className="mb-2 text-xl sm:text-2xl font-bold text-white text-center">
              info@spacexpakistan.com
            </h5>
            <p className="text-customRed hover:text-gray-400 text-center text-lg">
              info@spacexpakistan.com
            </p>
            <p className="mb-3 text-customRed hover:text-gray-400 text-center text-lg">
              +92-334-4403514
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCards;
